import axios from "axios"
import { print } from "./Uteis"
import { Alert } from "@mui/material"

//export let baseURL = "https://appprofnodeprods.appmapp.com.br"
export let baseURL = "https://nodeprofreact.appmapp.com.br"

switch (window.location.host) {
	case "192.168.1.25:3000":
		// alert("Pegou URL de produção!")
		// baseURL = "192.168.1.7:3001"
		// baseURL = "https://20250520t091145-dot-appprofnode-363918.rj.r.appspot.com"
		break
	case "localhost:3000":
		//baseURL = "http://localhost:4759"
		// baseURL = "https://20250520t091145-dot-appprofnode-363918.rj.r.appspot.com"
		// baseURL = "https://node-dot-appprofteste.rj.r.appspot.com/"
		break
	case "appprofhumb.mototaxionline.com":
		//baseURL = "https://node-dot-appprofteste.rj.r.appspot.com/"
		break
	case "appprofteste.rj.r.appspot.com":
		// baseURL = "https://appprofnodeprods.appmapp.com.br"
		// baseURL = "https://20250520t091145-dot-appprofnode-363918.rj.r.appspot.com"
		//baseURL = "https://node-dot-appprofteste.rj.r.appspot.com/"
		break
}

window.isLocalHost = window.location.host.includes("192.168") || window.location.host.includes("localhost")

if (window.isLocalHost) {
	baseURL = `http://${window.location.host.split(":")[0]}:4759`
}

const API = axios.create({
	baseURL: baseURL,
	timeout: 30000
})

// --- Acesso direto ao PHP (rollout gradual; flag em localStorage "acessoDireto") ---
import("./acessoDireto/adapter.js").then(({ criarAdapter }) => {
	const adapterPadrao = typeof axios.getAdapter === "function"
		? axios.getAdapter(axios.defaults.adapter)
		: axios.defaults.adapter

	const telemetria = (info) => {
		// registra falha da via direta via rota /log (fire-and-forget, sempre via Node)
		axios.post(`${baseURL}/appProfissional/acessar`, {
			dominio: info.dominio,
			rota: "/log",
			method: "POST",
			metodo: "POST",
			data: { tipo: "acessoDiretoFalhou", ...info }
		}).catch(() => {})
	}

	API.defaults.adapter = criarAdapter(adapterPadrao, axios, telemetria)
})

/**
 * Trava de segurança do recarregamento de sessão: se uma rota responder
 * tokenInvalido/usuarioInativo logo após um recarregamento, recarregar de novo
 * deixaria o app em loop (a URL recarregada perde os parâmetros de boot e a tela
 * fica branca para sempre). Permite no máximo um recarregamento a cada 30s.
 */
function podeRecarregarSessao() {
	try {
		const agora = Date.now()
		const ultimo = Number(window.sessionStorage.getItem("ultimoReloadSessao") ?? 0)

		if (agora - ultimo < 30000) return false

		window.sessionStorage.setItem("ultimoReloadSessao", String(agora))
		return true
	} catch (e) {
		return true
	}
}

API.interceptors.response.use((res) => {
	//alert(JSON.stringify(res));


	if (res.data?.resultado == false || ( res.data?.dados == undefined || res.data?.dados == null )) {
		// Erro quando resultado é false (estrutura com resultado, mensagem, codigo, aux, extra)
		const erroResultado = res.data

		// Extrair informações da URL do extra se disponível
		let hostDestino = null
		let portaDestino = null
		let urlDestino = null

		if (erroResultado?.extra?.url) {
			urlDestino = erroResultado.extra.url
			try {
				const urlObj = new URL(erroResultado.extra.url)
				hostDestino = urlObj.hostname
				portaDestino = urlObj.port || (urlObj.protocol === 'https:' ? '443' : '80')
			} catch (e) {
				// Se não conseguir fazer parse da URL
			}
		}

		// Montar objeto de erro com informações da requisição e resposta
		const erroInfo = {
			mensagem: erroResultado?.mensagem || "Erro retornado pela API",
			codigoErro: erroResultado?.codigo || erroResultado?.aux || null,
			requisicao: {
				method: (erroResultado?.extra?.metodo || res.config?.method || "UNKNOWN").toUpperCase(),
				url: res.config?.url || erroResultado?.extra?.url || "URL não disponível",
				baseURL: res.config?.baseURL || "",
				endpoint: erroResultado?.extra?.url || (res.config?.url ? `${res.config.baseURL}${res.config.url}` : "Endpoint não disponível"),
				urlDestino: urlDestino,
				hostDestino: hostDestino,
				portaDestino: portaDestino,
				params: res.config?.params || null,
				data: res.config?.data ? (typeof res.config.data === 'string' ? (() => { try { return JSON.parse(res.config.data) } catch { return res.config.data } })() : res.config.data) : null,
				headers: erroResultado?.extra?.headers || res.config?.headers || {}
			},
			resposta: {
				status: res.status || null,
				statusText: res.statusText || null,
				data: erroResultado
			},
			tipoErro: "ERRO_API",
			aux: erroResultado?.aux || null,
			resultado: erroResultado?.resultado !== undefined ? erroResultado.resultado : null,
			timestamp: new Date().toISOString()
		}

		// Disparar evento customizado para o contexto capturar
		if (window.dispatchEvent) {
			window.dispatchEvent(new CustomEvent('axios-error', { detail: erroInfo }))
		}

	} else if (res.data?.erroDetalhado != undefined) {
		// Erro detalhado retornado pela API (não é erro de requisição, mas erro da API)
		let erroDetalhado = res.data.erroDetalhado

		// Se erroDetalhado for string JSON, fazer parse
		if (typeof erroDetalhado === 'string') {
			try {
				erroDetalhado = JSON.parse(erroDetalhado)
			} catch (e) {
				// Se não conseguir fazer parse, usar a string como está
				console.error('Erro ao fazer parse do erroDetalhado:', e)
			}
		}

		// Montar objeto de erro com informações da requisição e resposta
		const erroInfo = {
			mensagem: erroDetalhado?.message || erroDetalhado?.mensagem || "Erro retornado pela API",
			codigoErro: erroDetalhado?.code || erroDetalhado?.codigo || erroDetalhado?.name || null,
			requisicao: {
				method: res.config?.method?.toUpperCase() || "UNKNOWN",
				url: res.config?.url || "URL não disponível",
				baseURL: res.config?.baseURL || "",
				endpoint: res.config?.url ? `${res.config.baseURL}${res.config.url}` : "Endpoint não disponível",
				params: res.config?.params || null,
				data: res.config?.data ? (typeof res.config.data === 'string' ? (() => { try { return JSON.parse(res.config.data) } catch { return res.config.data } })() : res.config.data) : null,
				headers: res.config?.headers || {}
			},
			resposta: {
				status: res.status || null,
				statusText: res.statusText || null,
				data: erroDetalhado
			},
			tipoErro: "ERRO_CONEXAO_API",
			stack: erroDetalhado?.stack || null,
			timestamp: new Date().toISOString()
		}

		// Extrair informações específicas do erro se disponível
		if (erroDetalhado?.config) {
			erroInfo.requisicao.urlDestino = erroDetalhado.config?.url || null
			if (erroDetalhado.config?.url) {
				try {
					const urlObj = new URL(erroDetalhado.config.url.startsWith('http') ? erroDetalhado.config.url : `${erroDetalhado.config.baseURL || ''}${erroDetalhado.config.url}`)
					erroInfo.requisicao.hostDestino = urlObj.hostname
					erroInfo.requisicao.portaDestino = urlObj.port || (urlObj.protocol === 'https:' ? '443' : '80')
				} catch (e) {
					// Se não conseguir fazer parse da URL
				}
			}
		}

		// Disparar evento customizado para o contexto capturar
		if (window.dispatchEvent) {
			window.dispatchEvent(new CustomEvent('axios-error', { detail: erroInfo }))
		}
	}

	if (res.data?.aux != undefined) {
		if (["tokenInvalido", "usuarioInativo"].includes(res.data.aux)) {
			if (window.AndroidInterface) {
				// Rotas que não derrubam a sessão. Além das de autenticação, as checagens
				// de módulo em segundo plano: o profissional em pós-cadastro ainda não tem
				// ativo = "S", então validarInatividade no PHP responde 401/usuarioInativo
				// e o recarregamento entrava em loop (tela branca permanente).
				const rotas = ["/validarToken", "/login", "/salvarImagemCDN", "/gestaoVagasModuloAtivo"]

				let rotaRequisicao = null
				try {
					rotaRequisicao = JSON.parse(res.config?.data)?.rota
				} catch (e) {
					rotaRequisicao = null
				}

				if (!rotas.includes(rotaRequisicao) && podeRecarregarSessao())
					window.AndroidInterface.reloadPage()
			} else {
				window.location.href.replace('/')
			}
		}
	}

	return res
}, (error) => {

	
	// Função de retry reutilizável para Network Error
	const tentarRetry = () => {
		// Verificar se é erro recuperável baseado na mensagem/código de erro
		const isErrorRecuperavel =
			error.message === "Network Error" ||
			error.code === "ERR_NETWORK" ||
			error.code === "ECONNABORTED" ||
			error.message?.toLowerCase().includes("timeout")

		if (!isErrorRecuperavel) return false

		// Parsear o data da requisição para verificar o método/rota (requisições via acessar)
		let data = error.config?.data ? (typeof error.config.data === 'string' ? (() => { try { return JSON.parse(error.config.data) } catch { return error.config.data } })() : error.config.data) : null
		const metodoDoData = data && typeof data === 'object' ? (data.method || data.metodo || '').toLowerCase() : null
		const urlRequisicao = error.config?.url || ''

		// Permitir retry: GET /config OU POST salvarImagemCDN
		const ehGetConfig = metodoDoData === 'get' && data?.rota === '/config'
		const ehSalvarImagemCDN = urlRequisicao.includes('salvarImagemCDN')

		if (!ehGetConfig && !ehSalvarImagemCDN) return false

		const retryCount = error.config._retryCount || 0
		const maxTentativas = ehSalvarImagemCDN ? 1 : 3

		if (retryCount >= maxTentativas) return false

		error.config._retryCount = retryCount + 1
		const delays = ehSalvarImagemCDN ? [2000] : [1500, 2500, 3500]
		const delay = delays[Math.min(retryCount, delays.length - 1)]

		return new Promise((resolve) => {
			setTimeout(() => resolve(API.request(error.config)), delay)
		})
	}
	
	// Tentar fazer retry primeiro (antes de disparar evento de erro)
	const retryPromise = tentarRetry()
	if (retryPromise) {
		return retryPromise
	}
	
	// Se não fez retry, continuar com o tratamento normal de erro
	
	// Interceptor de erro para capturar detalhes das requisições que falham
	if (error.response) {
		// Erro com resposta do servidor
		const erroInfo = {
			mensagem: error.response.data?.mensagem || error.message || "Erro na requisição",
			requisicao: {
				method: error.config?.method?.toUpperCase() || "UNKNOWN",
				url: error.config?.url || "URL não disponível",
				baseURL: error.config?.baseURL || "",
				endpoint: error.config?.url ? `${error.config.baseURL}${error.config.url}` : "Endpoint não disponível",
				params: error.config?.params || null,
				data: error.config?.data ? (typeof error.config.data === 'string' ? (() => { try { return JSON.parse(error.config.data) } catch { return error.config.data } })() : error.config.data) : null,
				headers: error.config?.headers || {}
			},
			resposta: {
				status: error.response?.status || null,
				statusText: error.response?.statusText || null,
				data: error.response?.data || null
			},
			timestamp: new Date().toISOString()
		}

		// Disparar evento customizado para o contexto capturar
		if (window.dispatchEvent) {
			window.dispatchEvent(new CustomEvent('axios-error', { detail: erroInfo }))
		}
	} else if (error.request) {
		// Erro sem resposta (timeout, rede, etc)
		const erroInfo = {
			mensagem: error.message || "Erro de conexão",
			requisicao: {
				method: error.config?.method?.toUpperCase() || "UNKNOWN",
				url: error.config?.url || "URL não disponível",
				baseURL: error.config?.baseURL || "",
				endpoint: error.config?.url ? `${error.config.baseURL}${error.config.url}` : "Endpoint não disponível",
				params: error.config?.params || null,
				data: error.config?.data ? (typeof error.config.data === 'string' ? (() => { try { return JSON.parse(error.config.data) } catch { return error.config.data } })() : error.config.data) : null,
				headers: error.config?.headers || {}
			},
			resposta: null,
			tipoErro: "SEM_RESPOSTA",
			timestamp: new Date().toISOString()
		}

		// Disparar evento customizado para o contexto capturar
		if (window.dispatchEvent) {
			window.dispatchEvent(new CustomEvent('axios-error', { detail: erroInfo }))
		}
	} else {
		// Erro ao configurar a requisição
		const erroInfo = {
			mensagem: error.message || "Erro ao configurar requisição",
			requisicao: {
				method: error.config?.method?.toUpperCase() || "UNKNOWN",
				url: error.config?.url || "URL não disponível",
				baseURL: error.config?.baseURL || "",
				endpoint: "Configuração inválida",
				params: null,
				data: null,
				headers: {}
			},
			resposta: null,
			tipoErro: "CONFIGURACAO",
			timestamp: new Date().toISOString()
		}

		// Disparar evento customizado para o contexto capturar
		if (window.dispatchEvent) {
			window.dispatchEvent(new CustomEvent('axios-error', { detail: erroInfo }))
		}
	}

	return Promise.reject(error)
})

export default API